// API service for communicating with Cloudflare D1 backend

const API_BASE_URL = import.meta.env.PROD
  ? '/api'
  : 'http://localhost:8788/api'; // For local Wrangler dev server

class CameraAPI {
  /**
   * Fetch all cameras with optional search and sorting
   * @param {string} search - Search query
   * @param {string} orderBy - Column to sort by
   * @param {string} order - Sort order (asc/desc)
   */
  async getCameras(search = '', orderBy = 'manufacturer', order = 'asc') {
    try {
      const params = new URLSearchParams();
      if (search) params.append('search', search);
      if (orderBy) params.append('orderBy', orderBy);
      if (order) params.append('order', order);

      const response = await fetch(`${API_BASE_URL}/cameras?${params}`);
      const data = await response.json();

      if (!data.success) {
        throw new Error(data.error || 'Failed to fetch cameras');
      }

      return data.data;
    } catch (error) {
      console.error('Error fetching cameras:', error);
      throw error;
    }
  }

  /**
   * Get a single camera by ID
   * @param {number} id - Camera ID
   */
  async getCamera(id) {
    try {
      const response = await fetch(`${API_BASE_URL}/cameras/${id}`);
      const data = await response.json();

      if (!data.success) {
        throw new Error(data.error || 'Failed to fetch camera');
      }

      return data.data;
    } catch (error) {
      console.error('Error fetching camera:', error);
      throw error;
    }
  }

  /**
   * Add a new camera
   * @param {Object} cameraData - Camera data object
   */
  async addCamera(cameraData) {
    try {
      const response = await fetch(`${API_BASE_URL}/cameras`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(cameraData),
      });

      const data = await response.json();

      if (!data.success) {
        throw new Error(data.error || 'Failed to add camera');
      }

      return data.data;
    } catch (error) {
      console.error('Error adding camera:', error);
      throw error;
    }
  }

  /**
   * Update an existing camera
   * @param {number} id - Camera ID
   * @param {Object} cameraData - Updated camera data
   */
  async updateCamera(id, cameraData) {
    try {
      const response = await fetch(`${API_BASE_URL}/cameras/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(cameraData),
      });

      const data = await response.json();

      if (!data.success) {
        throw new Error(data.error || 'Failed to update camera');
      }

      return data.data;
    } catch (error) {
      console.error('Error updating camera:', error);
      throw error;
    }
  }

  /**
   * Delete a camera
   * @param {number} id - Camera ID
   */
  async deleteCamera(id) {
    try {
      const response = await fetch(`${API_BASE_URL}/cameras/${id}`, {
        method: 'DELETE',
      });

      const data = await response.json();

      if (!data.success) {
        throw new Error(data.error || 'Failed to delete camera');
      }

      return true;
    } catch (error) {
      console.error('Error deleting camera:', error);
      throw error;
    }
  }
}

export default new CameraAPI();
